export default "__VITE_ASSET__Bwmyhjt5__"